
import { apiSlice } from "./apiSlice";
import { COACHINGCENTERBILLING } from "../constants";

export const coachingCenterBillingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBillingSettings: builder.query({
      query: (coachingCenterId) => ({
        url: `${COACHINGCENTERBILLING}/centers/${coachingCenterId}/settings`,
      }),

      providesTags: (result, error, coachingCenterId) => [
        {
          type: "CoachingCenterBillingSettings",
          id: coachingCenterId,
        },
      ],

      keepUnusedDataFor: 5,
    }),

    updateBillingSettings: builder.mutation({
      query: ({ coachingCenterId, data }) => ({
        url: `${COACHINGCENTERBILLING}/centers/${coachingCenterId}/settings`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: (result, error, { coachingCenterId }) => [
        {
          type: "CoachingCenterBillingSettings",
          id: coachingCenterId,
        },
        "BillingInvoice",
        "BillingDashboard",
      ],
    }),

    enableBillingSettings: builder.mutation({
      query: (coachingCenterId) => ({
        url: `${COACHINGCENTERBILLING}/centers/${coachingCenterId}/settings/enable`,
        method: "PUT",
      }),

      invalidatesTags: (result, error, coachingCenterId) => [
        {
          type: "CoachingCenterBillingSettings",
          id: coachingCenterId,
        },
        "BillingInvoice",
        "BillingDashboard",
      ],
    }),

    disableBillingSettings: builder.mutation({
      query: (coachingCenterId) => ({
        url: `${COACHINGCENTERBILLING}/centers/${coachingCenterId}/settings/disable`,
        method: "PUT",
      }),

      invalidatesTags: (result, error, coachingCenterId) => [
        {
          type: "CoachingCenterBillingSettings",
          id: coachingCenterId,
        },
        "BillingInvoice",
        "BillingDashboard",
      ],
    }),

    disableDiscount: builder.mutation({
      query: (coachingCenterId) => ({
        url: `${COACHINGCENTERBILLING}/centers/${coachingCenterId}/settings/discount/disable`,
        method: "PUT",
      }),

      invalidatesTags: (result, error, coachingCenterId) => [
        {
          type: "CoachingCenterBillingSettings",
          id: coachingCenterId,
        },
        "BillingInvoice",
        "BillingDashboard",
      ],
    }),

    deleteBillingSettings: builder.mutation({
      query: (coachingCenterId) => ({
        url: `${COACHINGCENTERBILLING}/centers/${coachingCenterId}/settings`,
        method: "DELETE",
      }),

      invalidatesTags: (result, error, coachingCenterId) => [
        {
          type: "CoachingCenterBillingSettings",
          id: coachingCenterId,
        },
        "BillingInvoice",
        "BillingDashboard",
      ],
    }),
  }),
});

export const {
  useGetBillingSettingsQuery,
  useUpdateBillingSettingsMutation,
  useEnableBillingSettingsMutation,
  useDisableBillingSettingsMutation,
  useDisableDiscountMutation,
  useDeleteBillingSettingsMutation,
} = coachingCenterBillingApiSlice;

